import IranMap from "./IranMapCanvas";

function Map() {
  return (
    <>
      <IranMap reportName={"جهادگران اعزام شده"} />

      {/* <Dialog
        open={showConfig}
        onClose={() => setShowConfig(false)}
        PaperProps={{
          style: {
            backgroundColor: "white",
            borderRadius: "20px",
            boxShadow: "none",
            width: "600px",
            margin: "100px auto",
            padding: "30px",
          },
        }}
      >
        <ThresholdForm
          initValues={{
            midValue: thresh?.midValue,
            criticalValue: thresh?.criticalValue,
          }}
          reportType={"MEMBERS_PER_PROVINCE"}
          onChange={(newThresh) => setThresh(newThresh)}
          onClose={() => setShowConfig(false)}
        />
      </Dialog> */}
    </>
  );
}

export default Map;
